var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-view","loading":_vm.loadingInitialResults},on:{"click":_vm.getResults}},[_vm._v("Get Results")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }